import {ref, onMounted, watch, onUnmounted} from "vue";
import { useStore } from "vuex";

export default {
    name: 'ChatPanelFloatingTrigger',
    props: {
        chatPanelActionId: {
            type: String,
            required: true
        },
        floatingTriggerText: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const store = useStore();
        const triggerElementRef = ref(null)
        const animationFinished = ref(false)
        const visible = ref(false)
        function initActionId() {
            store.dispatch("chatPanel/openChatAndHandleActionId", props.chatPanelActionId)
        }

        const handleIntersection = (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !animationFinished.value) {
                animationFinished.value = true;
                visible.value = true;
              }
            });
          };

        onMounted(() => {
            const observer = new IntersectionObserver(handleIntersection, {
              threshold: 0.5
            });
      
            if (triggerElementRef.value) {
              observer.observe(triggerElementRef.value);
            }
      
        });
        
        onUnmounted(() => {
          if (triggerElementRef.value) {
            observer.unobserve(triggerElementRef.value);
          }
        });

        return {
            visible,
            triggerElementRef,
            initActionId
        }
    }
}